import React from 'react';
import { useAdminStore } from '../../stores/useAdminStore';
import { useAdminVisible } from '../../hooks/useAdminVisible';
import '../ui/BrandFrame/BrandFrame.css';
import './AddEventButton.css';

interface AddEventButtonProps {
  seasonId: string;
  seasonName: string;
  year: number;
}

export const AddEventButton: React.FC<AddEventButtonProps> = ({
  seasonId,
  seasonName,
  year
}) => {
  const openEventCreateModal = useAdminStore(s => s.openEventCreateModal);
  const isVisible = useAdminVisible();

  if (!isVisible) {
    return null;
  }

  const handleClick = () => {
    openEventCreateModal({ seasonId, seasonName, year });
  };

  return (
    <button
      className="avatar-carousel-bubble add-event-button"
      onClick={handleClick}
      title={`Create new event for ${seasonName} ${year}`}
      aria-label={`Create new event for ${seasonName} ${year}`}
      data-testid="add-event-button"
    >
      <div className="avatar-bubble-inner">
        <div className="brand-frame avatar-bubble-gradient">
          <div className="brand-frame__surface avatar-bubble-image">
            <div className="add-event-icon">
              <span className="add-event-button__icon">+</span>
            </div>
          </div>
        </div>
        <span className="brand-frame__label avatar-bubble-username">Add Event</span>
      </div>
    </button>
  );
};
